import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService);

  const lang = translateService.currentLang || translateService.defaultLang;

  // If neither of these are available, then we don't set the header.
  // The browser will set it instead based on its own settings.

  if (lang) {
    req = req.clone({ setHeaders: { 'Accept-Language': lang } });
  }

  return next(req);
};
